import { render, staticRenderFns } from "./openAnswer.vue?vue&type=template&id=42bee3de&"
import script from "./openAnswer.vue?vue&type=script&lang=js&"
export * from "./openAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports